export function getGiftEnv() {
  return {
    zelle: (process.env.REACT_APP_GIFT_ZELLE || "").trim(),
    venmo: (process.env.REACT_APP_GIFT_VENMO || "").trim(),
    paypal: (process.env.REACT_APP_GIFT_PAYPAL || "").trim(),
    note: (process.env.REACT_APP_GIFT_NOTE || "").trim(),
    /** When set, Korean registry button links here (e.g. bank app URL). */
    registryKoreanUrl: (process.env.REACT_APP_REGISTRY_KOREAN_URL || "").trim(),
  };
}

export function formatGiftLines(env) {
  const lines = [];
  if (env.zelle) lines.push(`Zelle: ${env.zelle}`);
  if (env.venmo) lines.push(`Venmo: ${env.venmo}`);
  if (env.paypal) lines.push(`PayPal: ${env.paypal}`);
  if (env.note) lines.push(env.note);
  return lines.join("\n");
}
